import {customPluginAttrPrefix} from "@/components/tinyMce/plugins/tinyMceCustomPluginsConstants";

export const flipcardPluginName = 'flipcard';
export const flipcardCardIdAttr = `${customPluginAttrPrefix}-${flipcardPluginName}-card-id`;
export const flipcardCardNumberAttr = `${customPluginAttrPrefix}-${flipcardPluginName}-card-number`;
export const flipcardCardFaceAttr = `${customPluginAttrPrefix}-${flipcardPluginName}-face`;
export const flipcardCardActionAttr = `${customPluginAttrPrefix}-${flipcardPluginName}-action`;
export const flipcardCardContentTypeAttr = `${customPluginAttrPrefix}-${flipcardPluginName}-content-type`;
export const flipcardCardParamAttr = `${customPluginAttrPrefix}-${flipcardPluginName}-param`;
